import {
  CREATE_CREATOR_SESSION,
  GET_ALL_CREATOR_SESSIONS,
  GET_CREATOR_SESSION_BY_ID,
  UPDATE_CREATOR_SESSION,
  DELETE_CREATOR_SESSION,
  CREATE_CREATOR_AVAILABILITY,
  GET_CREATOR_AVAILABILITY,
  UPDATE_CREATOR_AVAILABILITY,
  DELETE_CREATOR_AVAILABILITY,
  CREATE_BOOKING,
  GET_CREATOR_BOOKINGS,
  GET_BOOKING_BY_ID,
  UPDATE_BOOKING,
  DELETE_BOOKING,
  GET_AVAILABLE_TIME_SLOTS,
  CREATE_SESSION_RATING,
  GET_SESSION_RATINGS,
  UPDATE_SESSION_RATING,
  GET_CREATOR_DASHBOARD,
  MINDFULNESS_LOADING,
  MINDFULNESS_ERROR,
  GET_ALL_CREATORS,
  SEARCH_SESSION_WITH_FILTERS,
  GET_USER_DASHBOARD,
  GET_CREATOR_BOOKING,
  GET_USER_BOOKINGS,
} from "../constants/actionTypes";
import { produce } from "immer";

const defaultState = {
  // Creator Sessions
  creatorSessions: [],
  currentSession: null,

  creators: [],

  searchSessionResult: [],

  // Creator Availability
  creatorAvailability: [],
  currentAvailability: null,

  // Bookings
  bookings: [],
  currentBooking: null,
  availableTimeSlots: [],
  bookingDetails: null,

  // Session Ratings
  sessionRatings: [],
  currentRating: null,

  // Creator Dashboard
  creatorDashboard: null,

  // User Dashboard
  userDashboard: null,

  userBookings: [],

  // Loading and Error states
  isLoading: false,
  error: null,
};

const mindfulnessReducer = produce((draft, action) => {
  switch (action.type) {
    // ============= CREATOR SESSION CASES =============
    case CREATE_CREATOR_SESSION:
      draft.creatorSessions.push(action.payload);
      draft.currentSession = action.payload;
      break;

    case GET_ALL_CREATOR_SESSIONS:
      draft.creatorSessions = action.payload;
      break;

    case SEARCH_SESSION_WITH_FILTERS:
      draft.searchSessionResult = action.payload;
      break;

    case GET_ALL_CREATORS:
      draft.creators = action.payload;
      break;

    case GET_CREATOR_SESSION_BY_ID:
      draft.currentSession = action.payload;
      break;

    case UPDATE_CREATOR_SESSION:
      const sessionIndex = draft.creatorSessions.findIndex(
        (session) => session.id === action.payload.id
      );
      if (sessionIndex !== -1) {
        draft.creatorSessions[sessionIndex] = action.payload;
      }
      draft.currentSession = action.payload;
      break;

    case DELETE_CREATOR_SESSION:
      draft.creatorSessions = draft.creatorSessions.filter(
        (session) => session.id !== action.payload
      );
      if (draft.currentSession?.id === action.payload) {
        draft.currentSession = null;
      }
      break;

    // ============= CREATOR AVAILABILITY CASES =============
    case CREATE_CREATOR_AVAILABILITY:
      draft.creatorAvailability.push(action.payload);
      draft.currentAvailability = action.payload;
      break;

    case GET_CREATOR_AVAILABILITY:
      draft.creatorAvailability = action.payload;
      break;

    case UPDATE_CREATOR_AVAILABILITY:
      const availabilityIndex = draft.creatorAvailability.findIndex(
        (avail) => avail.id === action.payload.id
      );
      if (availabilityIndex !== -1) {
        draft.creatorAvailability[availabilityIndex] = action.payload;
      }
      draft.currentAvailability = action.payload;
      break;

    case DELETE_CREATOR_AVAILABILITY:
      draft.creatorAvailability = draft.creatorAvailability.filter(
        (avail) => avail.id !== action.payload
      );
      if (draft.currentAvailability?.id === action.payload) {
        draft.currentAvailability = null;
      }
      break;

    // ============= BOOKING CASES =============
    case CREATE_BOOKING:
      draft.bookings.push(action.payload);
      draft.currentBooking = action.payload;
      break;

    case GET_CREATOR_BOOKINGS:
      draft.bookings = action.payload;
      break;

    case GET_CREATOR_BOOKING:
      draft.bookingDetails = action.payload;
      break;

    case GET_USER_BOOKINGS:
      draft.userBookings = action.payload;
      break;

    case GET_BOOKING_BY_ID:
      draft.currentBooking = action.payload;
      break;

    case UPDATE_BOOKING:
      const bookingIndex = draft.bookings.findIndex(
        (booking) => booking.id === action.payload.id
      );
      if (bookingIndex !== -1) {
        draft.bookings[bookingIndex] = action.payload;
      }
      draft.currentBooking = action.payload;
      break;

    case DELETE_BOOKING:
      draft.bookings = draft.bookings.filter(
        (booking) => booking.id !== action.payload
      );
      if (draft.currentBooking?.id === action.payload) {
        draft.currentBooking = null;
      }
      break;

    case GET_AVAILABLE_TIME_SLOTS:
      draft.availableTimeSlots = action.payload;
      break;

    // ============= SESSION RATING CASES =============
    case CREATE_SESSION_RATING:
      draft.sessionRatings.push(action.payload);
      draft.currentRating = action.payload;
      break;

    case GET_SESSION_RATINGS:
      draft.sessionRatings = action.payload;
      break;

    case UPDATE_SESSION_RATING:
      const ratingIndex = draft.sessionRatings.findIndex(
        (rating) => rating.id === action.payload.id
      );
      if (ratingIndex !== -1) {
        draft.sessionRatings[ratingIndex] = action.payload;
      }
      draft.currentRating = action.payload;
      break;

    // ============= CREATOR DASHBOARD CASES =============
    case GET_CREATOR_DASHBOARD:
      draft.creatorDashboard = action.payload;
      break;

    case GET_USER_DASHBOARD:
      draft.userDashboard = action.payload;
      break;

    // ============= LOADING AND ERROR CASES =============
    case MINDFULNESS_LOADING:
      draft.isLoading = action.payload;
      break;

    case MINDFULNESS_ERROR:
      draft.error = action.payload;
      draft.isLoading = false;
      break;

    default:
      break;
  }
}, defaultState);

export default mindfulnessReducer;
